<script>
import BaseModal from '@/components/_common/modal/BaseModal.vue'
export default {
  name: 'BioModal',
  extends: BaseModal,
  data: function () {
    return {
    }
  },
  computed: {
  },
  watch: {},
  methods: {
  }
}
</script>

<template>
  <MountingPortal
    mount-to="#modal-portal"
    append
    name="modal"
  >
    <transition
      name="base-modal"
    >
      <template>
        <div
          class="modal-mask base-modal card-modal"
          :class="{modalId: modalId, 'is-full-screen': fullScreen, 'is-dialog': isDialog}"
          @click="onMaskClick"
          v-show="show"
        >
          <div
            class="modal-container bio-container"
            :class="customClass"
            :style="customStyles"
            @click.stop
          >
            <header
              v-if="hasHeader"
              class="modal-header"
              :class="{'is-success': headerStyle === 'success', 'is-danger': headerStyle === 'danger'}"
            >
              <slot
                name="header"
              >
                header slot
              </slot>
              <button
                v-if="hasCloseButton"
                @click="close"
                class="delete"
              />
            </header>
            <div
              id="modalBody"
              ref="modalBody"
              class="modal-body"
              :style="contentAreaCustomStyles"
              :class="{'has-padding': hasBodyPadding, 'is-flex-column': isFlexColumn, 'auto-height': autoHeight}"
            >
              <div class="bio-content">
                <slot
                  name="content"
                >
                  content slot
                </slot>
              </div>
            </div>
            <footer
              v-if="hasFooter"
              class="modal-footer"
            >
              <slot
                name="footer"
              >
                footer slot
              </slot>
            </footer>
          </div>
        </div>
      </template>
    </transition>
  </MountingPortal>
</template>
<style lang="scss">

</style>
<style lang="scss" scoped>
.bio-container {
  .bio-image {
    min-width: 14rem;
    @include tablet {
      float: right;
      margin: 0 0 1rem 1rem;
    }

    img {
      border-radius: 0.25rem;
    }
  }
}
  .bio-container {
    .modal-body {
      background-color: #fff;
    }
    @include tablet {
      max-width: 50%;
    }
  }
</style>
